import * as React from "react";
import Star from "./star";
interface StarSendButtonType {
  className: string;
  image: string;
  text: string;
  stars: number;
  isLoading?: boolean;
}

export default function StarSendButton({
  className,
  image,
  text,
  stars,
  disabled,
  onClick,
  isLoading,
}: StarSendButtonType & { disabled?: boolean; onClick?: () => void }) {
  return (
    <div
      className={`${className} relative ${disabled || isLoading ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
      onClick={disabled || isLoading ? undefined : onClick}
    >
      <img
        src={image}
        alt="button-image"
        className="w-full h-full object-contain"
      />
      <p className="absolute top-0 w-full h-full flex items-center justify-center gap-2">
        {text}
        <Star className="w-8 h-8" color="white" />
        {stars}
      </p>
    </div>
  );
}
